// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file trade/v1/purchase_order_events.proto (package trade.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { PurchaseOrder, PurchaseOrderStatus } from "./purchase_order_pb.js";
import { file_trade_v1_purchase_order } from "./purchase_order_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file trade/v1/purchase_order_events.proto.
 */
export const file_trade_v1_purchase_order_events: GenFile = /*@__PURE__*/
  fileDesc("CiR0cmFkZS92MS9wdXJjaGFzZV9vcmRlcl9ldmVudHMucHJvdG8SCHRyYWRlLnYxIooCChJQdXJjaGFzZU9yZGVyRXZlbnQSNgoHY3JlYXRlZBgBIAEoCzIjLnRyYWRlLnYxLlB1cmNoYXNlT3JkZXJDcmVhdGVkRXZlbnRIABI2Cgd1cGRhdGVkGAIgASgLMiMudHJhZGUudjEuUHVyY2hhc2VPcmRlclVwZGF0ZWRFdmVudEgAEjYKB2RlbGV0ZWQYAyABKAsyIy50cmFkZS52MS5QdXJjaGFzZU9yZGVyRGVsZXRlZEV2ZW50SAASQwoOc3RhdHVzX2NoYW5nZWQYBCABKAsyKS50cmFkZS52MS5QdXJjaGFzZU9yZGVyU3RhdHVzQ2hhbmdlZEV2ZW50SABCBwoFZXZlbnQiTAoZUHVyY2hhc2VPcmRlckNyZWF0ZWRFdmVudBIvCg5wdXJjaGFzZV9vcmRlchgBIAEoCzIXLnRyYWRlLnYxLlB1cmNoYXNlT3JkZXIijgEKGVB1cmNoYXNlT3JkZXJVcGRhdGVkRXZlbnQSOAoXcHJldmlvdXNfcHVyY2hhc2Vfb3JkZXIYASABKAsyFy50cmFkZS52MS5QdXJjaGFzZU9yZGVyEjcKFnVwZGF0ZWRfcHVyY2hhc2Vfb3JkZXIYAiABKAsyFy50cmFkZS52MS5QdXJjaGFzZU9yZGVyIkwKGVB1cmNoYXNlT3JkZXJEZWxldGVkRXZlbnQSLwoOcHVyY2hhc2Vfb3JkZXIYASABKAsyFy50cmFkZS52MS5QdXJjaGFzZU9yZGVyIr0BCh9QdXJjaGFzZU9yZGVyU3RhdHVzQ2hhbmdlZEV2ZW50Ei8KDnB1cmNoYXNlX29yZGVyGAEgASgLMhcudHJhZGUudjEuUHVyY2hhc2VPcmRlchI2Cg9wcmV2aW91c19zdGF0dXMYAiABKA4yHS50cmFkZS52MS5QdXJjaGFzZU9yZGVyU3RhdHVzEjEKCm5ld19zdGF0dXMYAyABKA4yHS50cmFkZS52MS5QdXJjaGFzZU9yZGVyU3RhdHVzQi9aLXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLXRyYWRlL2FwaS92MTt0cmFkZV92MWIIZWRpdGlvbnNw6Ac", [file_trade_v1_purchase_order]);

/**
 * @generated from message trade.v1.PurchaseOrderEvent
 */
export type PurchaseOrderEvent = Message<"trade.v1.PurchaseOrderEvent"> & {
  /**
   * @generated from oneof trade.v1.PurchaseOrderEvent.event
   */
  event: {
    /**
     * @generated from field: trade.v1.PurchaseOrderCreatedEvent created = 1;
     */
    value: PurchaseOrderCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: trade.v1.PurchaseOrderUpdatedEvent updated = 2;
     */
    value: PurchaseOrderUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: trade.v1.PurchaseOrderDeletedEvent deleted = 3;
     */
    value: PurchaseOrderDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: trade.v1.PurchaseOrderStatusChangedEvent status_changed = 4;
     */
    value: PurchaseOrderStatusChangedEvent;
    case: "statusChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message trade.v1.PurchaseOrderEvent.
 * Use `create(PurchaseOrderEventSchema)` to create a new message.
 */
export const PurchaseOrderEventSchema: GenMessage<PurchaseOrderEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_events, 0);

/**
 * @generated from message trade.v1.PurchaseOrderCreatedEvent
 */
export type PurchaseOrderCreatedEvent = Message<"trade.v1.PurchaseOrderCreatedEvent"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.PurchaseOrderCreatedEvent.
 * Use `create(PurchaseOrderCreatedEventSchema)` to create a new message.
 */
export const PurchaseOrderCreatedEventSchema: GenMessage<PurchaseOrderCreatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_events, 1);

/**
 * @generated from message trade.v1.PurchaseOrderUpdatedEvent
 */
export type PurchaseOrderUpdatedEvent = Message<"trade.v1.PurchaseOrderUpdatedEvent"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder previous_purchase_order = 1;
   */
  previousPurchaseOrder?: PurchaseOrder;

  /**
   * @generated from field: trade.v1.PurchaseOrder updated_purchase_order = 2;
   */
  updatedPurchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.PurchaseOrderUpdatedEvent.
 * Use `create(PurchaseOrderUpdatedEventSchema)` to create a new message.
 */
export const PurchaseOrderUpdatedEventSchema: GenMessage<PurchaseOrderUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_events, 2);

/**
 * @generated from message trade.v1.PurchaseOrderDeletedEvent
 */
export type PurchaseOrderDeletedEvent = Message<"trade.v1.PurchaseOrderDeletedEvent"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;
};

/**
 * Describes the message trade.v1.PurchaseOrderDeletedEvent.
 * Use `create(PurchaseOrderDeletedEventSchema)` to create a new message.
 */
export const PurchaseOrderDeletedEventSchema: GenMessage<PurchaseOrderDeletedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_events, 3);

/**
 * @generated from message trade.v1.PurchaseOrderStatusChangedEvent
 */
export type PurchaseOrderStatusChangedEvent = Message<"trade.v1.PurchaseOrderStatusChangedEvent"> & {
  /**
   * @generated from field: trade.v1.PurchaseOrder purchase_order = 1;
   */
  purchaseOrder?: PurchaseOrder;

  /**
   * @generated from field: trade.v1.PurchaseOrderStatus previous_status = 2;
   */
  previousStatus: PurchaseOrderStatus;

  /**
   * @generated from field: trade.v1.PurchaseOrderStatus new_status = 3;
   */
  newStatus: PurchaseOrderStatus;
};

/**
 * Describes the message trade.v1.PurchaseOrderStatusChangedEvent.
 * Use `create(PurchaseOrderStatusChangedEventSchema)` to create a new message.
 */
export const PurchaseOrderStatusChangedEventSchema: GenMessage<PurchaseOrderStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_trade_v1_purchase_order_events, 4);

